/**
 * @generated SignedSource<<d1d922a1126d5e7cdbe95fee75a7ef60>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CreateReferralPartnerSourceModal_referralPartner$data = {
  readonly rowId: any;
  readonly " $fragmentType": "CreateReferralPartnerSourceModal_referralPartner";
};
export type CreateReferralPartnerSourceModal_referralPartner$key = {
  readonly " $data"?: CreateReferralPartnerSourceModal_referralPartner$data;
  readonly " $fragmentSpreads": FragmentRefs<"CreateReferralPartnerSourceModal_referralPartner">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CreateReferralPartnerSourceModal_referralPartner",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "rowId",
      "storageKey": null
    }
  ],
  "type": "ReferralPartner",
  "abstractKey": null
};

(node as any).hash = "8f21697e5e79ae4e7cd5130c46c00cc2";

export default node;
